/** Stored in products.level — who the product is allocated for */
export const AUDIENCE_VALUES = ['Junior', 'Senior', 'Both'];

export function normalizeAudienceLevel(raw) {
  if (raw === 'Junior' || raw === 'Senior' || raw === 'Both') return raw;
  return 'Both';
}

export function audienceBadgeLabel(level) {
  const v = normalizeAudienceLevel(level);
  if (v === 'Both') return 'Junior & Senior';
  return v;
}

/** Catalog filter: junior = Junior only, senior = Senior only, all = everything */
export function productMatchesAudienceFilter(product, filter) {
  const lvl = normalizeAudienceLevel(product?.level);
  if (filter === 'all') return true;
  if (filter === 'junior') return lvl === 'Junior';
  if (filter === 'senior') return lvl === 'Senior';
  return true;
}
